import { render, staticRenderFns } from "./third-vendors.vue?vue&type=template&id=0f5ca841&"
import script from "./third-vendors.vue?vue&type=script&lang=js&"
export * from "./third-vendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports